class VideoPlayer extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.playing = false
    this.muted = false
    this.seeking = false
  }

  setupListeners () {
    super.setupListeners()

    this.video = this.els.video.element

    // Video events
    this.handlePlay = this.handlePlay.bind(this)
    this.handlePause = this.handlePause.bind(this)
    this.handleEnd = this.handleEnd.bind(this)
    this.handleVolumeChange = this.handleVolumeChange.bind(this)
    this.handleTimeUpdate = this.handleTimeUpdate.bind(this)

    this.listeners.add(this.video, 'play', this.handlePlay)
    this.listeners.add(this.video, 'pause', this.handlePause)
    this.listeners.add(this.video, 'ended', this.handleEnd)
    this.listeners.add(this.video, 'volumechange', this.handleVolumeChange)
    this.listeners.add(this.video, 'timeupdate', this.handleTimeUpdate)

    // Control events
    this.togglePlayback = this.togglePlayback.bind(this)
    this.toggleVolume = this.toggleVolume.bind(this)
    this.seekTime = this.seekTime.bind(this)

    this.listeners.add(this.els.cover.element, 'click', this.togglePlayback)
    this.listeners.add(this.els.playback.element, 'click', this.togglePlayback)
    this.listeners.add(this.els.volume.element, 'click', this.toggleVolume)
    this.listeners.add(this.els.bar.element, 'change', this.seekTime)

    this.listeners.add(this.els.bar.element, 'pointerdown', () => {
      this.seeking = true
    })

    this.listeners.add(this.els.bar.element, 'pointerup', () => {
      this.seeking = false
    })

    // Resize event
    this.debouncedOnResize = window.BAO.Utils.debounce(() => {
      if (
        (this.type === 'desktop' && !window.BAO.MediaBreakpoints.isSm) ||
        (this.type === 'mobile' && window.BAO.MediaBreakpoints.isSm)
      ) {
        this.video.pause()
      }
    }, 200)

    window.addEventListener('resize', this.debouncedOnResize)
  }

  handlePlay () {
    this.setAttribute('playing', true)
    this.setAttribute('played', true)
    this.playing = true
  }

  handlePause () {
    this.removeAttribute('playing')
    this.playing = false
  }

  handleEnd () {
    this.removeAttribute('played')

    if (this.dataset.timestamp) {
      setTimeout(() => {
        if (!this.playing) {
          this.els.timestamp.element.innerText = this.dataset.timestamp
        }
      }, 300)
    }
  }

  handleVolumeChange () {
    this.muted = this.video.volume === 0

    if (this.muted) {
      this.setAttribute('muted', true)
      return
    }

    this.removeAttribute('muted')
  }

  handleTimeUpdate () {
    if (this.video.seeking || this.seeking) {
      return
    }

    this.duration = this.video.duration
    const currentTime = this.video.currentTime

    if (!currentTime || isNaN(this.duration)) {
      return
    }

    // Update timestamp
    const remaining = Math.floor(this.duration - currentTime)
    const minutes = Math.floor(remaining / 60)
    let seconds = remaining % 60
    seconds = String(seconds).padStart(2, '0')

    this.els.timestamp.element.innerText = `-${minutes}:${seconds}`

    // Update progress bar
    const progress = Math.ceil((currentTime / this.duration) * 100)
    this.els.bar.element.value = progress
  }

  togglePlayback () {
    if (this.video.seeking) {
      return
    }

    if (this.playing) {
      this.video.pause()
      return
    }

    this.video.play()
  }

  toggleVolume () {
    if (this.muted) {
      this.video.volume = 1
      return
    }

    this.video.volume = 0
  }

  seekTime () {
    if (this.video.seeking) {
      return
    }

    const progress = this.els.bar.element.value / 100
    this.video.currentTime = progress * this.duration
  }

  get type () {
    return this.dataset.type
  }
}

if (!customElements.get('video-player')) {
  customElements.define('video-player', VideoPlayer)
}
